//导入封装http
import http from "@/api/request";
//对外暴露axios函数
// 获取新闻列表
export const reqNewsList = () => {
  return http({url:'/news/',method:'get'})
}
// 获取案例列表
export const reqCgalList = ()=>{
  return http({url:'/cgal/',method:'get'})
}
// 获取案例分类列表
export const reqCgalCentList=(cent)=>{
  console.log(`/cgal/${cent}/`);
  return http({url:`/cgal/${cent}/`,method:'get'});

}
// 获取案例搜索列表
export const reqCgalSearchList=(title)=>{
  return http({url:`/cgal/search/${title}`,method:'get'})
}
// 获取人事招聘列表
export const reqRszpList = () => {
  return http({url:'/rszp/',method:'get'})
}
//英文
// 获取新闻列表
export const reqNewsenList = () => {
  return http({url:'/newsen/',method:'get'})
}
export const reqCgalenList = ()=>{
  return http({url:'/cgalen/',method:'get'})
}
// 获取案例分类列表
export const reqCgalenCentList=(cent)=>{
  return http({url:`/cgalen/${cent}/`,method:'get'});

}
// 获取案例搜索列表
export const reqCgalenSearchList=(title)=>{
  return http({url:`/cgalen/search/${title}`,method:'get'})
}
// 获取人事招聘列表
export const reqRszpenList = () => {
  return http({url:'/rszpen/',method:'get'})
}